import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { NotificationService } from '@odin/odin-core';
import { RoleGuardService } from '@odin/odin-authentication';;

@Injectable()
export class ReportsGuardService implements CanActivate {
  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private roleGuardService: RoleGuardService
  ) {}

  canActivate(
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.roleGuardService.hasPermission('reports:Manage')) return true;

    this.router.navigate(['/dashboard']);
    this.notificationService.AccessDeniedDialog('Reports & Analytics');
    return false;
  }
}
